import React from 'react';
import { getStatusBadge, getLeaveTypeLabel } from './leaveHelpers.jsx';

/**
 * Single leave-request card, extracted from LeaveManagement.jsx so it can be
 * memoized (avoids re-rendering every card whenever an unrelated card's
 * review/payment state changes) and used as a virtualized row.
 *
 * `onReview(leave, action)` mirrors the original inline
 * `openReviewModal(leave, 'approved' | 'rejected')` handlers.
 */
function LeaveRequestRow({ leave, onReview }) {
  return (
    <div className="request-card">
      <div className="card-header">
        <div className="employee-info">
          <h3>{leave.employee?.firstName} {leave.employee?.lastName}</h3>
          <span className="employee-email">{leave.employee?.email}</span>
        </div>
        {getStatusBadge(leave.status)}
      </div>

      <div className="card-body">
        <div className="info-row">
          <span className="label">Leave Type:</span>
          <span className="value">{getLeaveTypeLabel(leave.leaveType)}</span>
        </div>
        <div className="info-row">
          <span className="label">Days:</span>
          <span className="value">{leave.leaveCount} day{leave.leaveCount > 1 ? 's' : ''}</span>
        </div>
        <div className="info-row">
          <span className="label">Reason:</span>
          <span className="value">{leave.reason}</span>
        </div>
        <div className="info-row">
          <span className="label">Submitted:</span>
          <span className="value">
            {new Date(leave.createdAt).toLocaleDateString()} at{' '}
            {new Date(leave.createdAt).toLocaleTimeString()}
          </span>
        </div>

        {leave.reviewedBy && (
          <div className="review-info">
            <p>
              Reviewed by: {leave.reviewedBy.firstName} {leave.reviewedBy.lastName}
              <br />
              on {new Date(leave.reviewedAt).toLocaleDateString()}
            </p>
          </div>
        )}

        {leave.rejectionReason && (
          <div className="rejection-box">
            <strong>Rejection Reason:</strong> {leave.rejectionReason}
          </div>
        )}
      </div>

      {leave.status === 'pending' && (
        <div className="card-actions">
          <button
            className="btn-approve"
            onClick={() => onReview(leave, 'approved')}
          >
            ✓ Approve
          </button>
          <button
            className="btn-reject"
            onClick={() => onReview(leave, 'rejected')}
          >
            ✗ Reject
          </button>
        </div>
      )}
    </div>
  );
}

export default React.memo(LeaveRequestRow);
